import React, { useEffect, useState } from "react";
import { IAdquirinte } from "..";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Button, TextField } from "@mui/material";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";
import { ModalDivX } from "../../../ModalDivX";
import { cpfMask } from "../../../../Services/cpfMask";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { validateCPF } from "../../../../Services/validateCPF";
import api from "../../../../Services/api";
import { useParams } from "react-router";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { cnpjMask } from "../../../../Services/cnpjMask";
import { isRural } from "../../../../Utils/isRural";
import { useAdquirinte } from "../../../../Storage/Adquirente";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
    padding: "1rem", // Reduzindo o padding
    zIndex: 999,
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  adquirinte: IAdquirinte;
  handleSetadquirinte(n_adquirinte: IAdquirinte): void;
}

export function ModalAdquirinte({
  open,
  onClose,
  adquirinte,
  handleSetadquirinte,
}: Props) {
  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { getAdquirintes } = useAdquirinte();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [NOME, setNOME] = useState("");
  const [CPF_CNPJ, setCPF_CNPJ] = useState("");
  const [RUA, setRUA] = useState("");
  const [NUMERO, setNUMERO] = useState<number | string>("");
  const [COMPLEMENTO, setCOMPLEMENTO] = useState("");
  const [MUNICIPIO, setMUNICIPIO] = useState("");
  const [UF, setUF] = useState("");
  const [BAIRRO, setBAIRRO] = useState("");
 

  const { id } = useParams();

  useEffect(() => {
    if (adquirinte.ID) {
      setNOME(adquirinte.NOME);
      setCPF_CNPJ(
        adquirinte.CPF ? cpfMask(adquirinte.CPF) : cnpjMask(adquirinte.CNPJ)
      );
      setRUA(adquirinte.RUA);
      setNUMERO(adquirinte.NUMERO);
      setCOMPLEMENTO(adquirinte.COMPLEMENTO);
      setUF(adquirinte.UF);
      setBAIRRO(adquirinte.BAIRRO);
      setMUNICIPIO(adquirinte.MUNICIPIO);
    } else {
      setNOME("");
      setCPF_CNPJ("");
      setRUA("");
      setNUMERO("");
      setCOMPLEMENTO("");
      setUF("");
      setBAIRRO("");
      setMUNICIPIO("");
    }
  }, [open]);

  function validateForm() {
    if (CPF_CNPJ.trim().length > 14) {
      if (!validateCNPJ(limpa_cpf_cnpj(CPF_CNPJ))) {
        setError({
          message: "O CNPJ digitado é inválido!",
          title: "CNPJ Inválido",
        });
        return false;
      }
    } else {
      if (!validateCPF(limpa_cpf_cnpj(CPF_CNPJ))) {
        setError({
          message: `O CPF digitado é inválido!`,
          title: "CPF Inválido",
        });
        return false;
      }
    }

    if (NOME.trim().length === 0) {
      setError({
        message: "O nome digitado é inválido!",
        title: "Adquirinte Inválido",
      });
      return false;
    }

    if (BAIRRO.trim().length === 0) {
      setError({
        message: "O BAIRRO digitado é inválido!",
        title: "BAIRRO Inválido",
      });
      return false;
    }

    if (RUA.trim().length === 0) {
      setError({
        message: "A RUA digitada é inválida!",
        title: "RUA Inválida",
      });
      return false;
    }

    if (isNaN(Number(NUMERO)) || Number(NUMERO) <= 0) {
      setError({
        message: "O NÚMERO digitado é inválido!",
        title: "NÚMERO Inválido",
      });
      return false;
    }

    if (MUNICIPIO.trim().length === 0) {
      setError({
        message: "O MUNICÍPIO digitado é inválido!",
        title: "MUNICÍPIO Inválido",
      });
      return false;
    }

    if (UF.trim().length !== 2) {
      setError({
        message: "A Unidade Federativa digitada é inválida!",
        title: "Unidade Federativa Inválida",
      });
      return false;
    }

    return true;
  }

  async function buscarUltimoRegistro() {
    try {
      setLoading(true);
      const { data } = await api.post(
        `/adquirinte-transmitente/${cartorio.ID}`,
        { cpf_cnpj: limpa_cpf_cnpj(CPF_CNPJ) }
      );
      setNOME(data[0].NOME);
      setRUA(data[0].RUA);
      setBAIRRO(data[0].BAIRRO);
      setCOMPLEMENTO(data[0].COMPLEMENTO);
      setMUNICIPIO(data[0].MUNICIPIO);
      setNUMERO(data[0].NUMERO);
      setUF(data[0].UF);
    } catch (error) {
      setError({
        title: "Ops",
        message: "Nenhum registro encontrado com esta chave!",
      });
    } finally {
     
      setLoading(false);
    }
  }

  async function post() {
    if (validateForm()) {
      try {
        if (cartorioIsLogged) {
          await checarToken();
        }

        if (funcionarioCartorioIsLogged) {
          await checarTokenFuncionario();
        }

        setLoading(true);
        const cpf =
          limpa_cpf_cnpj(CPF_CNPJ).length === 11
            ? limpa_cpf_cnpj(CPF_CNPJ)
            : null;
        const cnpj =
          limpa_cpf_cnpj(CPF_CNPJ).length === 14
            ? limpa_cpf_cnpj(CPF_CNPJ)
            : null;

        const { data } = adquirinte.ID
          ? await api.put(`/adquirinte`, {
              NOME,
              RUA,
              NUMERO,
              COMPLEMENTO,
              IMOVEL_ID: isRural() ? null : id,
              IMOVEL_RURAL_ID: isRural() ? id : null,
              CPF: cpf,
              CNPJ: cnpj,
              MUNICIPIO,
              BAIRRO,
              UF,
              ID: adquirinte.ID,
            })
          : await api.post(`/adquirinte`, {
              NOME,
              RUA,
              NUMERO,
              COMPLEMENTO,
              IMOVEL_ID: isRural() ? null : id,
              IMOVEL_RURAL_ID: isRural() ? id : null,
              CPF: cpf,
              CNPJ: cnpj,
              MUNICIPIO,
              BAIRRO,
              UF,
            });

        handleSetadquirinte(data);
        onClose();
      } catch (error) {
        setError({
          title: "Não foi salvar as alterações!",
          message: "Não foi possível salvar as alterações do adquirinte!",
        });
      } finally {
        getAdquirintes();
        setLoading(false);
      }
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <div style={{}}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="ADQUIRENTE"
            variant="outlined"
            fullWidth
            value={NOME}
            onChange={(ev) => setNOME(ev.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="CPF | CNPJ"
            variant="outlined"
            fullWidth
            value={CPF_CNPJ}
            onChange={(ev) => {
              let teste = "";
           
              if (ev.target.value.length <= 14) {
                teste = cpfMask(ev.target.value);
              } else {
                teste = cnpjMask(ev.target.value);
              }
              setCPF_CNPJ(teste);
            }}
            style={{ marginBottom: "10px" }}
          />
        </div>    <>
            {" "}
            <Button
              variant="contained"
              style={{ marginTop: "8px", width: "100%" }}
              onClick={buscarUltimoRegistro}
            >
               Buscar por CPF/CNPJ
            </Button>
            <br />
            <br />
          </>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="BAIRRO"
            variant="outlined"
            fullWidth
            value={BAIRRO}
            onChange={(ev) => setBAIRRO(ev.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="RUA"
            variant="outlined"
            fullWidth
            value={RUA}
            onChange={(ev) => setRUA(ev.target.value)}
            style={{ marginBottom: "10px" }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="NÚMERO"
            variant="outlined"
            fullWidth
            value={NUMERO}
            onChange={(ev) => setNUMERO(ev.target.value.replace(/\D/g, ""))}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="Complemento"
            variant="outlined"
            fullWidth
            value={COMPLEMENTO}
            onChange={(ev) => setCOMPLEMENTO(ev.target.value)}
            style={{ marginBottom: "10px" }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="MUNICÍPIO"
            variant="outlined"
            fullWidth
            value={MUNICIPIO}
            onChange={(ev) => setMUNICIPIO(ev.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            label="UF"
            variant="outlined"
            fullWidth
            value={UF}
            onChange={(ev) => {
              let valor = ev.target.value.replaceAll(" ","");
              if (valor.length <= 2) {
                setUF(valor);
              }
            }}
            style={{ marginBottom: "10px" }}
          />
        </div>
      </div>
      <Button variant="contained" onClick={post} style={{ width: "100%" }}>
        CONFIRMAR
      </Button>

      <ModalLoader loading={loading} />

      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
